module.exports = __webpack_public_path__ + "img/continuearrow.c880e7c2.svg";